import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { UserUrl } from '../../../shared/urls/user.url';
import { environment } from '../../../../environments/environment';

@Injectable()
export class ManageUserService {
    constructor(public baseService: BaseService) {
    }

    getUserList(param) {
        const url = UserUrl.GET_CENTRE_USERS;
        return this.baseService.getData(url, param);
    }

    resetPassword(id) {
        const url = UserUrl.RESET_PASSWORD;
        return this.baseService.postData(url + `/${id}?returnUrl=${environment.authConfig.postLogoutRedirectUri}`, null);
    }

    removeUser(id) {
        const url = UserUrl.REMOVE_CENTRE_USER.replace('{userId}', id);
        return this.baseService.delete(url);
    }
    resendActiveLink(id, activeLink) {
        const url = UserUrl.RESEND_ACTIVE_LINK;
        return this.baseService.postData(url + `/${id}?activeLink=${activeLink}`, null);
    }
    
    changeUserStatus(param) {
        const url = UserUrl.CHANGE_USER_STATUS.replace('{id}', param.id).replace('{status}', param.status);
        return this.baseService.postData(url, null);
    }

    getUserRoleList() {
        const url = UserUrl.GET_ROLES;
        return this.baseService.getData(url);
    }

    getUserInfo(id) {
        const url = UserUrl.GET_USER_URL;
        return this.baseService.getData(url + `/${id}`);
    }

    updateUserInfo(id, param) {
        const url = UserUrl.GET_USER_URL;
        return this.baseService.update(url + `/${id}`, param);
    }
}


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-user/manage-user.service.ts